import { injectIntl } from 'react-intl';
import AddressInput from './AddressInput';

export default injectIntl(AddressInput);
